import { createFileRoute } from "@tanstack/react-router";
import { SkillDetailPage } from "../components/skills/SkillDetailPage";

function SkillDetailRoute() {
  const { skillId } = Route.useParams();
  return <SkillDetailPage key={skillId} skillId={skillId} />;
}

export const Route = createFileRoute("/_app/operators/skills/$skillId")({
  component: SkillDetailRoute,
});
